import { useState, useEffect } from 'react';

export const useMediaQuery = (query: string): boolean => {
  // Initialize with a safe default based on the query
  const getInitialState = () => {
    // During SSR, window is undefined
    if (typeof window === 'undefined') {
      return false;
    }
    return window.matchMedia(query).matches;
  };

  const [matches, setMatches] = useState(getInitialState);

  useEffect(() => {
    // Guard for SSR
    if (typeof window === 'undefined') {
      return;
    }

    const media = window.matchMedia(query);
    
    // Set initial value
    const updateMatches = () => {
      setMatches(media.matches);
    };
    
    updateMatches();

    // Define listener
    const listener = (e: MediaQueryListEvent) => {
      setMatches(e.matches);
    };
    
    // Add listener
    media.addEventListener('change', listener);
    
    // Cleanup
    return () => media.removeEventListener('change', listener);
  }, [query]);

  return matches;
};

export const useIsMobile = () => useMediaQuery('(max-width: 768px)');
export const useIsTablet = () => useMediaQuery('(max-width: 1024px)');
export const useIsDesktop = () => useMediaQuery('(min-width: 1024px)');